import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleChipComponent } from './components/simple-chip.component';

@NgModule({
  declarations: [SimpleChipComponent],
  imports: [CommonModule],
  exports: [SimpleChipComponent],
})
export class SimpleChipModule {}
